import { format, intlFormat } from 'date-fns';
import { AuditService } from './AuditService';
import { ContractService } from './ContractService';
import { CookieManager } from './CookieManager';
import { BasicStore } from './BasicStore';
import { AdminService } from './AdminService';
import { env } from '../../env';
import { spinnerStore } from '../Stores/SpinnerStore/SpinnerStore';
type SpinnerListener = (estado: boolean) => void;
export class Singleton {

    private static instance: Singleton;
    private listeners: SpinnerListener[] = [];
    private cookie: CookieManager;
    private audit = new AuditService();
    private contracService = new ContractService();
    private adminService = new AdminService();
    private cacheImage: any = [];
    private office: any = {}

    private account: any = {};
    private idFunctionalList: any = [];
    private groupsOnList: any = [];
    private idBossGroup: any = [];
    private menu: any = [];
    public spin = false;
    public eventos: any;
    private regionalSets: any = {
        Locale: "en-US",
        Currency: "USD",
        Min: 2,
        Max: 2
    };
    private dollarUSLocale = Intl.NumberFormat('en-US');
    private permisos: any = [];
    public rolContratos: any = [];
    private linkPermisions: any = {};
    public currentURI: any = {};

    public mapBudgetID = [];
    public defaultCache = [];
    private lastView = '';
    public accountPhoto = '#';
    public contractStore;
    public encrypKey: string | undefined;

    private printLog: boolean = env.PRINT_LOG ?? false;
    private isMovil: boolean;
    private windowSizeHeight: number;
    private windowSizeWidth: number;
    private loginType: string;
    private metaData: {};

    public bossArea = [];
    public employeeContract = [];
    public groupsBpm = [];
    public bossPlan = [];
    public preparerPlan = [];
    private imgLogo = "logo-amc-negro.png";

    private constructor() {

        this.eventos = {
            spin: false
        };
        this.cookie = new CookieManager("/");
        this.contractStore = new BasicStore('COMPRAS');
        this.encrypKey = undefined;
        this.isMovil = false;
    }

    setOffice(office: any) {
        this.office = office;
    }

    getOffice() {
        return this.office;
    }

    // Método para que los componentes se suscriban
    subscribe(listener: SpinnerListener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }

    // Método para activar/desactivar spinner
    spinner(estado: boolean) {
        // this.spin = estado;
        spinnerStore.setSpinner(estado);
        this.listeners.forEach(listener => listener(estado));
    }

    // Obtener el estado actual
    getStateSpinner() {
        return spinnerStore.getState();
    }

    public setCookie(name: string, value: string, days: number) {
        if (name === 'yek')
            this.encrypKey = value;

        // this.cookie.setCookie1(name, value, days);
        this.setSessionItem(name, value);
    }
    public getCookie(name: string) {
        // return this.cookie.getCookie1(name);
        return this.getSessionItem(name);
    }
    public removeCookie(name: string) {
        this.cookie.setCookie(name, '', -1);
    }
    public purgeCookie() {
        this.cookie.deleteAllCookies();
    }
    public decodeUTF8(text: any) {
        if (text === undefined || text === null)
            return '';
        else
            return new TextDecoder("utf-8").decode(new Uint8Array([...text].map(c => c.charCodeAt(0))));
    }
    public decodeUTF8Buffer(textoRecibido: any) {
        let text = '';
        try {

            text = new TextDecoder("utf-8").decode(new Uint8Array(textoRecibido.split('').map(c => c.charCodeAt(0))));
        } catch (error) {

        }

        return text
    }


    public pushAccountInfo(data: any) {
        try {
            this.employeeContract = data.EmployeeContract.map(item => item.DataBeanProperties);
            this.preparerPlan = data.PreparerPlan.map(item => item.DataBeanProperties);
            this.bossArea = data.BossArea.map(item => item.DataBeanProperties);

            this.bossPlan = data.JefePlan.map(item => item.DataBeanProperties);
            this.groupsBpm = data.GruposBpm.map(item => item.DataBeanProperties);
        } catch (error) {

        }
    }

    public getMyBossArea() {
        return this.bossArea;
    }

    getMyEmployeeContract() {
        return this.employeeContract;
    }

    getMyGroupsBPM() {
        return this.groupsBpm;
    }

    public setCacheItem(key: string, value: any) {
        this.defaultCache[key] = value;
    }

    public deleteCacheItem(partialKey: string) {
        for (const key in this.defaultCache) {
            if (key.includes(partialKey)) {
                delete this.defaultCache[key];
            }
        }
    }

    public getCacheItem(key: string) {
        return this.defaultCache[key];
    }


    //Auditoria 

    getRolesContratos() {
        if (this.rolContratos.length == 0) {
            this.contracService.getHiringConstants("HIRINGROLES").subscribe(
                (resp: any) => {
                    if (resp.DataBeanProperties.ObjectValue) {
                        let temp = resp.DataBeanProperties.ObjectValue;
                        temp.forEach((item: any) => {
                            this.rolContratos.push({
                                id: item.DataBeanProperties.Value,
                                name: item.DataBeanProperties.Property
                            })
                        });




                    }
                }
            )
        }
        return this.rolContratos;
    }

    public getAudit(): AuditService {
        return this.audit;
    }


    public view(obs: string, bean: any) {
        let b = {
            IDAction: this.audit.VIEW,
            JsonBefore: JSON.stringify(bean ? bean : '{}'),
            State: 1,
            Observations: obs,
            IDAccount: this.getAccountID(),
            DataBeanClass: '',
            IDLn: 0
        }
        if (this.lastView != b.Observations) {
            this.lastView = b.Observations;
            this.audit.updateAuditFunction(b).subscribe(
                (resp: any) => {
                    ////console.log("AUDIT ", resp);

                }

            )
        }

    }
    public update(bean: any) {
        let uri = this.currentURI.URL ? this.currentURI.URL : "NA";
        let b = {
            IDAction: this.audit.UPDATE,
            JsonBefore: JSON.stringify(bean ? bean : '{}'),
            State: 1,
            Observations: "El usuario ha modificado " + uri,
            IDAccount: this.getAccountID(),
            DataBeanClass: '',
            IDLn: 0
        }
    }

    public download(obs: string) {
        let uri = this.currentURI.URL ? this.currentURI.URL : "NA";

        let b = {
            IDAction: this.audit.DOWNLOAD,
            JsonBefore: '{}',
            State: 1,
            Observations: "descarga modulo " + uri + " " + obs,
            IDAccount: this.getAccountID(),
            DataBeanClass: '',
            IDLn: 0
        }

        this.audit.updateAuditFunction(b).subscribe(
            (resp: any) => { }
        );

    }



    public makeAcction(obs: string, bean: any) {
        let uri = this.currentURI.URL ? this.currentURI.URL : "NA";

        let b = {
            IDAction: this.audit.ACTIVON,
            JsonBefore: JSON.stringify(bean ? bean : {}),
            State: 1,
            Observations: "Acción " + uri + " " + obs,
            IDAccount: this.getAccountID(),
            DataBeanClass: '',
            IDLn: 0
        }


    }
    public create(bean: any) {
        let uri = this.currentURI.URL ? this.currentURI.URL : "NA";
        let b = {
            IDAction: this.audit.CREATE,
            JsonBefore: JSON.stringify(bean ? bean : {}),
            State: 1,
            Observations: "El usuario ha creado en " + uri,
            IDAccount: this.getAccountID(),
            DataBeanClass: '',
            IDLn: 0
        }

    }
    public delete(idBean: number, bean: any) {
        let uri = this.currentURI.URL ? this.currentURI.URL : "NA";
        let b = {
            IDAction: this.audit.DELETE,
            JsonBefore: JSON.stringify(bean ? bean : {}),
            State: 1,
            Observations: "El usuario ha eliminado en " + uri,
            IDAccount: this.getAccountID(),
            DataBeanClass: '',
            IDDataBean: idBean,
            IDLn: 0
        }

    }

    //Auditoria 

    public static getInstance(): Singleton {
        if (!Singleton.instance) {
            Singleton.instance = new Singleton();

        }

        return Singleton.instance;
    }


    public spinner1(estado: boolean) {
        this.spin = estado;
        this.eventos.spin = estado;
        // localStorage.setItem("eventos", JSON.stringify(this.eventos));
        window.dispatchEvent(new Event("storage"));
    }

    public startSessionAffiliate(affiliate: any) {
        this.setSessionItem("affiliate_session", JSON.stringify(affiliate));
    }

    public setMetaDataUser(data: any) {
        this.metaData = data;
    }

    public getMetaDataUser(): any {
        return this.metaData;
    }

    public getAffiliate() {
        const affiliate = this.getSessionItem("affiliate_session") != "" ? JSON.parse(this.getSessionItem("affiliate_session")) : {}
        return affiliate;
    }

    public startSesion(Account: any) {



        if (Account.IDAccount === 0) {
            this.account = {
                IDAccount: 0
            };
            localStorage.setItem('admin', "true");
        }
        else {
            this.account = Account;
        }

        this.account.session = this.getCurrenDate2();
        //console.log("Iniciando sesion ", this.account);
        this.setCookie("code", JSON.stringify(this.account), 1);

    }

    public setPermision(p: any) {
        this.permisos = p;
    }
    public canEdit() {

        let c = false;
        if (this.linkPermisions) {
            if (this.linkPermisions.editar === true) {
                c = true;
            }
        }
        return c;
    }
    public canDelete() {

        let c = false;
        if (this.linkPermisions) {
            if (this.linkPermisions.eliminar === true) {
                c = true;
            }
        }
        return c;
    }
    public canCreate() {



        let c = false;
        if (this.linkPermisions) {
            if (this.linkPermisions.crear === true) {
                c = true;
            }
        }
        return c;
    }

    public canExport() {
        let c = false;
        if (this.linkPermisions) {
            if (this.linkPermisions.exportar === true) {
                c = true;
            }
        }
        return c;
    }

    public canView() {
        let c = false;
        if (this.linkPermisions) {
            if (this.linkPermisions.ver === true) {
                c = true;
            }
        }
        return c;
    }

    public getLinkPermisions() {

        return this.linkPermisions;
    }
    public havePermision(link: string) {
        let permiso = false;
        // console.log(link);

        this.permisos.forEach((m: any) => {
            if (m.URL == link) {
                permiso = true;
                this.linkPermisions = JSON.parse(m.IDLnPermissions ? m.IDLnPermissions : '{}');
                this.currentURI = m;

            }
        })


        if (link == '/admin/perfil')
            permiso = true;

        return permiso;
    }
    public havePermision64(link: string) {
        let permiso = false;


        try {
            let base = JSON.parse(atob(link));

            if (base) {
                if (base.IDLn) {
                    let menus = this.permisos.filter(item => item.IDLn == base.IDLn);

                    if (menus.length > 0) {
                        permiso = true;
                        this.linkPermisions = JSON.parse(menus[0].IDLnPermissions ? menus[0].IDLnPermissions : '{}');
                        this.currentURI = menus[0];
                    }


                } else {
                    let menus = this.permisos.filter(item => item.IDRemoteAbstractAction == base.IDRemoteAbstractAction);

                    if (menus.length > 0) {
                        permiso = true;
                        this.linkPermisions = JSON.parse(menus[0].IDLnPermissions ? menus[0].IDLnPermissions : '{}');
                        this.currentURI = menus[0];
                    }

                }

            }



        } catch (error) {

        }




        return permiso;
    }

    public cleanMap(object: any) {
        return Object.fromEntries(Object.entries(object).filter(([_, v]) => v !== null));
    }

    public getIMGLogo() {
        return this.imgLogo;
    }
    public getAccess() {
        return this.linkPermisions;
    }

    public setIDLnFunctionalArea = (list) => {
        if (list) {
            this.idFunctionalList = list
        }
    }

    public getIDLnFunctional = () => {
        if (this.idFunctionalList) {
            return this.idFunctionalList
        }
    }

    public setGroupOnMember = (list) => {
        if (list) {
            this.groupsOnList = list
        }
    }

    public getGroupOnList = () => {
        if (this.groupsOnList) {
            return this.groupsOnList
        }
    }

    public getIDBossGroupAssingned = (idlnFunctinalID: number): any => {
        if (this.groupsOnList && Array.isArray(this.groupsOnList)) {
            const group = this.groupsOnList.find(item => item.DataBeanProperties.IDLn === idlnFunctinalID);
            if (group) {
                return group.DataBeanProperties.IDBoss;
            }
        }
        return null;
    };

    public settMoneyFormater(regional: string) {
        let x: any = {};
        if (regional && regional.trim() !== "") {
            x = JSON.parse(regional);
            this.regionalSets = x;
        } else {
            console.error("El parámetro 'regional' está vacío o no es válido.");
        }
    }

    public getMoneyFormater() {
        return this.regionalSets;
    }

    public getAccount() {
        ////console.log("getAccount => ",this.account);

        let code = this.getSessionItem('code') || "{}";
        ////console.log("COOKIE => ",code);
        let acc = null;
        if (code) {
            acc = JSON.parse(code);
            this.account = acc;
        }

        return acc;
    }

    public getAccountID() {
        let id = null;
        this.account = this.getAccount();
        if (this.account != null) {
            id = this.account.IDAccount;
        }
        return id;
    }
    public closeSesion() {
        localStorage.clear();
        this.purgeCookie();
        return true;
    }
    public getRandomInt() {
        return Math.floor(Math.random() * 10000);
    }
    public setMenuUsuario(menuUsuario: any) {
        this.menu = menuUsuario;
    }

    public simplificarLista(lista = []) {
        let lista2: any = [];

        lista.map((element) => {

        })

        return lista2;
    }
    public parseDate(originalDate: any) {
        let ret = "";
        if (typeof (originalDate)) {

            const dateObject = new Date(originalDate);

            const year = dateObject.getFullYear();
            const month = String(dateObject.getMonth() + 1).padStart(2, '0');
            const day = String(dateObject.getDate()).padStart(2, '0');
            const hours = String(dateObject.getHours()).padStart(2, '0');
            const minutes = String(dateObject.getMinutes()).padStart(2, '0');
            const seconds = String(dateObject.getSeconds()).padStart(2, '0');

            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            ret = formattedDate;
            //console.log(formattedDate); // Salida: "2022-01-08 16:43:16"

        }
        return ret;
    }
    public formatearFecha(date: Date) {
        let fecha = "";
        import('date-fns/locale/es').then((locale) => {
            const fechaFormateada = format(date, 'dd MMMM yyyy', { locale: locale.default });
            fecha = fechaFormateada;
            //console.log(fechaFormateada); // Esto imprimirá la fecha en español en la consola
        });
        return fecha;
    };

    public getCurrenDate() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    public getCurrenDate2() {
        const now = new Date();
        return now.toISOString().slice(0, 19).replace('T', ' ');
    }

    public getCurrenYear() {
        return parseInt((new Date().toISOString().slice(0, 4)));
    }
    public renderConstant(constant: any, id: number) {

        let value = '';
        value = constant.map((item: any) => {
            if (item.id === id)
                return item.name;
        });

        return value;

    }

    public getCurrentMonth() {
        return new Date().getMonth();
    }

    public getCurrentDay() {
        return new Date().getDay();
    }

    public renderValue(valor: any) {
        let value1 = valor;

        // Intenta convertir el valor a un número
        if (!isNaN(valor)) {
            return parseInt(valor);
        }

        // Intenta analizar el valor como una fecha
        const date = new Date(valor);
        if (!isNaN(date.getTime())) {
            return this.formatearFecha(date);
        }


        return value1;
    }

    public isNumber = (n: any) => (typeof (n) === 'number' || n instanceof Number);
    public formatField = (value: any) => {
        let val = value;

        if (this.isNumber(value)) {
            // Asegúrate de que el valor es un número primitivo
            const numericValue = typeof value === 'number' ? value : value.valueOf();
            val = "<div class='text-end'>" + this.dollarUSLocale.format(numericValue) + "</div>";
        }
        else if (typeof val === "boolean") {
            val = val ? "Si" : "No";
        }
        else {
            val = `<div>${value ? value : ''}</div>`;
        }
        return val;

    }

    public getLoginType = () => {
        return this.loginType;
    }

    public setLoginType = (type: string) => {
        this.loginType = type;
    }


    public setWindowSize = (width: number, height: number) => {
        this.windowSizeWidth = width;
        this.windowSizeHeight = height;

        // Detección robusta de móvil:
        if (typeof window !== "undefined" && typeof window.matchMedia === "function") {
            this.isMovil = window.matchMedia("(max-width: 990.40px)").matches;
        } else {
            const viewportWidth =
                typeof window !== "undefined"
                    ? window.visualViewport?.width ?? window.innerWidth
                    : width;

            this.isMovil = viewportWidth <= 990.40;
        }
    };


    public getWindowSize = () => {
        return {
            width: this.windowSizeWidth,
            height: this.windowSizeHeight
        };
    }

    public getIsMovil = () => {
        return this.isMovil;
    }

    public formatFieldMask = (value: any, mask: number | null) => {
        let val = value;
        if (mask) {
            switch (mask) {
                case 1://numero
                    val = `<div class='miNumero'>${parseFloat(value ?? 0)}</div>`;
                    break;
                case 12://decimal
                    val = val = `<div class='text-end text-nowrap'>${new Intl.NumberFormat(
                        this.regionalSets.Locale, {
                        style: "decimal",
                        currency: this.regionalSets.Currency,
                        minimumFractionDigits: this.regionalSets.Min,
                        maximumFractionDigits: this.regionalSets.Max
                    }).format(parseFloat(value ?? 0))}</div>`;
                    break;
                case 11://numero redondeado
                    val = `<div class='miNumero'>${Math.round(parseInt(value ?? 0))}</div>`;
                    break;
                case 2: //dinero
                    // val = val = "<div class='text-end text-nowrap'> $ " + this.dollarUSLocale.format(value ?? 0) + "</div>";
                    val = val = `<div class='text-end text-nowrap'>${new Intl.NumberFormat(
                        this.regionalSets.Locale, {
                        style: "currency",
                        currency: this.regionalSets.Currency,
                        minimumFractionDigits: this.regionalSets.Min,
                        maximumFractionDigits: this.regionalSets.Max
                    }).format(parseFloat(value ?? 0))}</div>`;
                    break;
                case 22://dinero reondeado
                    // val = val = "<div class='text-end text-nowrap'> $ " + this.dollarUSLocale.format(Math.round(parseInt(value ?? 0))) + "</div>";
                    val = val = `<div class='text-end text-nowrap'>${new Intl.NumberFormat(
                        this.regionalSets.Locale, {
                        style: "currency",
                        currency: this.regionalSets.Currency,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    }).format(parseInt(value ?? 0))}</div>`;
                    break;
                case 3: //texto
                    val = `<div class='miTexto'>${value ? value : ''}</div>`
                    break;
                case 33: //texto sin wrap
                    val = `<div class='miTextoNW'>${value ? value : ''}</div>`
                    break;
                case 4: //MyEditor
                    val = `<div class='fit-content-wysysy'>${value ? value : ''}</div>`
                    break;
                case 5: //solo fecha
                    val = `<div class='mifecha text-nowrap'>${value ? value.slice(0, 10) : ''}</div>`
                    break;
                case 6: //solo fecha dd-mm-yyyy                   
                    // let f = value ? value.slice(0, 10) : '';
                    if (value ? value.slice(0, 10) : '' != '') {
                        val = `<div class='mifecha text-nowrap'>${this.convertirFecha(value.slice(0, 10))}</div>`
                    }
                    else {
                        val = `<div class='mifecha text-nowrap'></div>`
                    }
                    break;
                case 66: //solo fecha dd-mm-yyyy hh:mm
                    if (value ? value.slice(0, 16) : '' != '') {
                        val = `<div class='mifecha text-nowrap'>${value.slice(0, 16)}</div>`
                    }
                    else {
                        val = `<div class='mifecha text-nowrap'></div>`
                    }
                    break;
                case 7: //Cambiar los booleanos por iconos
                    val = val ?
                        `<div class='d-flex align-items-center justify-content-center'><i class='bx bx-check-circle text-success' style='font-size: 1rem;'></i></div>`
                        :
                        `<div class='d-flex align-items-center justify-content-center'><i class='ri-close-fill text-danger' style='font-size: 1rem;'></i></div>`;
                    break;
                case 77: //Cambiar los booleanos 
                    val = val ?
                        `<div class='d-flex align-items-center justify-content-center'>SI</div>`
                        :
                        `<div class='d-flex align-items-center justify-content-center'>NO</div>`;
                    break;
                default:
                    val = `<p>${val}</p>`;
            }
        } else {
            if (this.isNumber(value)) {
                const numericValue = typeof value === 'number' ? value : value.valueOf();
                val = "<div class='text-end'>" + this.dollarUSLocale.format(numericValue) + "</div>";

            }
            else if (typeof val === "boolean") {

                val = val ? "Si" : "No";

            }
            else {
                val = `<div>${value ? value : ''}</div>`
                // val = `<div class='text-capitalize'>${value ? value : ''}</div>`
            }
        }



        return val;
    }
    public convertirFecha(formatoOriginal) {
        const [year, month, day] = formatoOriginal.split("-");
        return `${day}-${month}-${year}`;
    }
    public formatMoney = (value: any): string => {
        try {
            const numericValue = Number(value);


            if (isNaN(numericValue)) {
                return "0";
            }

            return this.dollarUSLocale.format(Math.floor(numericValue));
        } catch (error) {

            return "0";
        }
    }


    public formatMoneyText = (value: any): string => {
        const numericValue = Number(value);

        if (isNaN(numericValue) || numericValue <= 0) {
            return "0";
        }

        return new Intl.NumberFormat(
            this.regionalSets.Locale, {
            style: "currency",
            currency: this.regionalSets.Currency,
            minimumFractionDigits: this.regionalSets.Min,
            maximumFractionDigits: this.regionalSets.Max
        }
        ).format(numericValue);
    }



    public formatMoneyNew = (value: string): string => {
        if (this.isNumber(value)) {
            const numberValue = parseFloat(value); // Permite decimales
            if (numberValue > 0) {
                return this.dollarUSLocale.format(numberValue);
            }
        }
        return '';
    };

    public getEntityName(bean: any) {
        let name =
            (bean.DataBeanProperties.Name1 ? bean.DataBeanProperties.Name1 : ' ') + ' ' +
            (bean.DataBeanProperties.Name2 ? bean.DataBeanProperties.Name2 : ' ') + ' ' +
            (bean.DataBeanProperties.Surname1 ? bean.DataBeanProperties.Surname1 : ' ') + ' ' +
            (bean.DataBeanProperties.Surname2 ? bean.DataBeanProperties.Surname2 : ' ');

        return name;
    }

    public basicName(nombre: string) {
        // Obtener la fecha y hora actual
        var fecha = new Date();
        var dia = fecha.getDate();
        var mes = fecha.getMonth() + 1; // Los meses comienzan en 0
        var year = fecha.getFullYear();
        var hora = fecha.getHours();
        var minutos = fecha.getMinutes();
        var segundos = fecha.getSeconds();

        // Crear un nombre aleatorio
        var nombreAleatorio = nombre + "_" + dia + mes + year + "_" + hora + minutos + segundos;


        return nombreAleatorio;
    }
    public esNumerico(valor) {
        return /^\d+$/.test(valor) || /^-\d+$/.test(valor) || /^(\d+\.\d+|\.\d+|\d+)$/.test(valor);
    }
    private esDouble(valor) {
        return /^-?\d*\.?\d+$/.test(valor);
    }

    public handleFormChange(bean: any, e: any) {

        // como usar 
        // setRow(single.handleFormChange({...row},e));


        if (e.target.name) {

            if (this.esNumerico(e.target.value)) {
                bean = { ...bean, [e.target.name]: parseInt(e.target.value) };
            }
            else if (e.target.type === 'number' || e.target.type == 'change') {
                if (this.esDouble(e.target.value)) {
                    bean = { ...bean, [e.target.name]: parseFloat(e.target.value) };
                }
                else if (this.esNumerico(e.target.value)) {
                    bean = { ...bean, [e.target.name]: parseInt(e.target.value) };
                }
            }
            else {
                bean = { ...bean, [e.target.name]: e.target.value };
            }

        }

        return bean;
    }
    public getValueInput(e: any): number | string | undefined {


        let valor: number | string | undefined = undefined;

        if (e.target.name) {
            const { type, value } = e.target;

            if (type === "select-one" || type === "select-multiple") {
                // Si es un select, convertir siempre a número
                const parsedValue = parseInt(value, 10);
                valor = isNaN(parsedValue) ? value : parsedValue;
            } else if (type === "number" || (this.esNumerico(value) && !/^0\d+/.test(value))) {
                // Si es un input type="number" o es un valor numérico (sin ceros a la izquierda), convertir a número
                valor = parseFloat(value);
            } else if (type === "text") {
                // Si es un input type="text" y el valor tiene caracteres mixtos, devolverlo como string
                valor = value;
            } else {
                // Si no cumple ninguna de las condiciones anteriores, devolverlo tal cual
                valor = value;
            }
        }

        return valor;
    }



    public sendEmailMessage(idaccount: number, subject: string | null, message: string) {

        this.adminService.getAccountByID(idaccount).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    let acc = resp.DataBeanProperties.ObjectValue;
                    if (acc.DataBeanProperties) {

                        let to = acc.DataBeanProperties.eMail;
                        if (to !== undefined || to !== null)
                            this.adminService.sendCustonEmailMessage([to], subject, message).subscribe(
                                (resp: any) => {


                                }
                            )
                    }
                }
            }
        )
    }
    public jsonToBootstrapTable(json: Record<string, any>): string {
        const rows = Object.entries(json).map(([key, value]) => {
            const valStr = typeof value === 'object' && value !== null
                ? JSON.stringify(value, null, 2)
                : String(value);
            return `
                <tr>
                    <td><strong>${key}</strong></td>
                    <td><pre class="mb-0">${valStr}</pre></td>
                </tr>`;
        });

        return `            
            <table class="tablecustom table table-bordered table-striped table-hover">               
                <tbody>
                    ${rows.join('\n')}
                </tbody>
            </table> `;
    }

    public trasformDataBeanToList(lista: any, columCode: string, columnValue: string) {
        const tmp = [];
        if (lista)
            if (lista.length > 0) {
                lista.forEach(element => {
                    tmp.push({
                        codigo: element.DataBeanProperties[columCode],
                        valor: element.DataBeanProperties[columnValue]
                    })
                });
            }
        // console.log(tmp);

        return tmp;
    }

    public printOut(message: any) {

        if (this.printLog)
            console.log(message);
    }
    public printTable(message: any) {

        if (this.printLog)
            console.table(message);
    }
    public printError(message: any) {

        if (this.printLog)
            console.warn(message);
    }

    // --- Reemplazo de cookies: usamos sessionStorage ahora ---
    public setSessionItem(name: string, value: string) {
        if (name === 'yek')
            this.encrypKey = value;

        try {
            sessionStorage.setItem(name, value);
        } catch (error) {
            console.error("Error setting sessionStorage item", error);
        }
    }

    addImageCache(name: string, image: any) {
        //console.log("cache => ", name);

        this.cacheImage[name] = image;
        localStorage.setItem(name, image);
        // localStorage.setItem("media",JSON.stringify(this.cacheImage));
    }

    getImageCache(name) {
        return localStorage.getItem(name);
        // return this.cacheImage[name];
    }

    public getSessionItem(name: string): string | null {
        try {
            return sessionStorage.getItem(name);
        } catch (error) {
            console.error("Error getting sessionStorage item", error);
            return null;
        }
    }

    public removeSessionItem(name: string) {
        try {
            sessionStorage.removeItem(name);
        } catch (error) {
            console.error("Error removing sessionStorage item", error);
        }
    }

    public purgeSession() {
        try {
            sessionStorage.clear();
        } catch (error) {
            console.error("Error clearing sessionStorage", error);
        }
    }

    // --- Nueva parte: uso de IndexedDB ---
    private dbName = 'SingletonDB';
    private dbVersion = 1;
    private storeName = 'SingletonStore';

    private openDB(): Promise<IDBDatabase> {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.dbName, this.dbVersion);

            request.onupgradeneeded = (event) => {
                const db = (event.target as IDBOpenDBRequest).result;
                if (!db.objectStoreNames.contains(this.storeName)) {
                    db.createObjectStore(this.storeName);
                }
            };

            request.onsuccess = () => {
                resolve(request.result);
            };

            request.onerror = () => {
                reject(request.error);
            };
        });
    }

    public async setIndexedDBItem(key: string, value: any): Promise<void> {
        try {
            const db = await this.openDB();
            const transaction = db.transaction(this.storeName, 'readwrite');
            const store = transaction.objectStore(this.storeName);
            store.put(value, key);
        } catch (error) {
            console.error("Error setting IndexedDB item", error);
        }
    }

    public async getIndexedDBItem<T = any>(key: string): Promise<T | undefined> {
        try {
            const db = await this.openDB();
            return new Promise<T | undefined>((resolve, reject) => {
                const transaction = db.transaction(this.storeName, 'readonly');
                const store = transaction.objectStore(this.storeName);
                const request = store.get(key);

                request.onsuccess = () => {
                    resolve(request.result as T);
                };

                request.onerror = () => {
                    reject(request.error);
                };
            });
        } catch (error) {
            console.error("Error getting IndexedDB item", error);
            return undefined;
        }
    }

    public async removeIndexedDBItem(key: string): Promise<void> {
        try {
            const db = await this.openDB();
            const transaction = db.transaction(this.storeName, 'readwrite');
            const store = transaction.objectStore(this.storeName);
            store.delete(key);
        } catch (error) {
            console.error("Error removing IndexedDB item", error);
        }
    }

    public async purgeIndexedDB(): Promise<void> {
        try {
            const db = await this.openDB();
            const transaction = db.transaction(this.storeName, 'readwrite');
            const store = transaction.objectStore(this.storeName);
            store.clear();
        } catch (error) {
            console.error("Error clearing IndexedDB store", error);
        }
    }
    public calcularEdad(birthDateString: string): number {
        const birthDate = new Date(birthDateString);
        if (isNaN(birthDate.getTime())) {
            throw new Error("Formato de fecha inválido. Usa yyyy-mm-dd");
        }

        const today = new Date();
        let edad = today.getFullYear() - birthDate.getFullYear();

        const mesActual = today.getMonth();
        const mesNacimiento = birthDate.getMonth();

        // Ajuste si aún no ha cumplido años este año
        if (
            mesActual < mesNacimiento ||
            (mesActual === mesNacimiento && today.getDate() < birthDate.getDate())
        ) {
            edad--;
        }

        return edad;
    }

}